import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
function formatDebugJson(value) {
    if (value == null)
        return '(none)';
    if (typeof value === 'string')
        return value;
    return JSON.stringify(value, null, 2);
}
export function WorkflowDebugPanel({ debug }) {
    const [open, setOpen] = useState(false);
    const meta = debug.url
        ? `POST ${debug.url}${debug.httpStatus ? ` · HTTP ${debug.httpStatus}` : ''}`
        : '';
    return (_jsxs("div", { className: "bubble-footer", children: [_jsx("button", { type: "button", className: "bubble-debug-toggle", onClick: () => setOpen((prev) => !prev), children: open ? 'Hide debug' : 'Debug' }), open && (_jsxs("div", { className: "bubble-debug-panel", children: [meta && _jsx("p", { className: "bubble-debug-meta", children: meta }), _jsxs("div", { className: "bubble-debug-block", children: [_jsx("h5", { children: "Sent to workflow" }), _jsx("pre", { children: formatDebugJson(debug.request) })] }), _jsxs("div", { className: "bubble-debug-block", children: [_jsx("h5", { children: "Returned from workflow" }), _jsx("pre", { children: formatDebugJson(debug.response) })] })] }))] }));
}
